
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    OCTSHORTGAME_ACTION,
    ALL_OCTSHORTGAME,
    ALL_OCTSHORTGAMESHOT,
    ADD_OCTSHORTGAME,
    FETCH_OCTSHORTGAME,
    EDIT_OCTSHORTGAME,
    DELETE_OCTSHORTGAME,
    FETCH_OCTSHORTGAMECHART,
    FETCH_SHORTSHOTCHART,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * On Course Short Game Actions
 */

export const allOCTShortGame = () => {

    return (dispatch) => {
        dispatch({ type: OCTSHORTGAME_ACTION });
        return axios.get(AppConfig.apiurl + '/api/getcourserandom', { headers: AuthHeader.header })
            .then(response => {
                const alldata = response.data.data;
                dispatch({ type: ALL_OCTSHORTGAME, payload: alldata });
            });
    }

}

export const studentOCTShortGame = (id, start, end) =>{
    
    var payload={
        "id":id,
        "startdate":start,
        "enddate":end
    }

    return (dispatch) => { 
        dispatch({ type:OCTSHORTGAME_ACTION, });
        return axios.post(AppConfig.apiurl+'/api/studentcourserandom', payload,{ headers: AuthHeader.header })         
        .then(response => { 
            const alldata=response.data.data;
            dispatch({ type: ALL_OCTSHORTGAME, payload: alldata }); 
        });
    
    }
}

export const allOCTShortGameShot = () => {

    return (dispatch) => {
        dispatch({ type: OCTSHORTGAME_ACTION });
        return axios.get(AppConfig.apiurl + '/api/getcourserandomshot', { headers: AuthHeader.header })
            .then(response => {
                const alldata = response.data.data;
                dispatch({ type: ALL_OCTSHORTGAMESHOT, payload: alldata });
            });
    }

}

export const addOCTShortGameShot = (data, sepmore) => {
    var id=data.target.student.value;
    var payload = {
        "totval": 1,
        "student_1": data.target.student.value,
        "sgdate": data.target.seldate.value,
        "shtot_1": sepmore,
    }

    for (let i = 0; i < sepmore; i++) {

        var distance = 'shot_' + i;
        var distanceval = data.target[distance].value;
        var right = 'right_' + i;
        var rightval = data.target[right].value;
        var left = 'left_' + i;
        var leftval = data.target[left].value;
        var short = 'short_' + i;
        var shortval = data.target[short].value;
        var long = 'long_' + i;
        var longval = data.target[long].value;
        var area = 'area_' + i;
        var areaval = data.target[area].value;
        var contact='contact_'+i;            
        var contactval=data.target[contact].value;
        var sepopt = 'putt_' + i;
        var seoptval = data.target[sepopt].value;
        var septravel = 'missedgreen_' + i;
        var setrvalval = data.target[septravel].value;

        var adval = i + 1;
        var distadd = 'shottype_1_' + adval;
        var rightadd = 'right_1_' + adval;
        var leftadd = 'left_1_' + adval;
        var shortadd = 'short_1_' + adval;
        var longadd = 'long_1_' + adval;
        var areaadd = 'area_1_' + adval;
        var contadd='contact_1_'+adval;
        var sepoptadd = 'putt_1_' + adval;
        var septraveladd = 'dhg_1_' + adval;

        payload[distadd] = distanceval;
        payload[rightadd] = rightval;
        payload[leftadd] = leftval;
        payload[shortadd] = shortval;
        payload[longadd] = longval;
        payload[areaadd] = areaval;
        payload[contadd] = contactval;
        payload[sepoptadd] = seoptval;
        payload[septraveladd] = setrvalval;

    }

    return (dispatch) => {
        dispatch({ type: OCTSHORTGAME_ACTION, });
        return axios.post(AppConfig.apiurl + '/api/addcourserandom', payload, { headers: AuthHeader.header })
            .then(response => {
                var resdata = response.data;
                if (resdata.status === 1) {
                    studentOCTShortGame(id, '', '')(dispatch);
                    fetchShortGameShotChart(id, '', '', '', '', '')(dispatch);
                    NotificationManager.success(resdata.message);
                    dispatch({ type: ADD_OCTSHORTGAME });
                }
                return Promise.resolve(resdata);

            });

    }
}

export const fetchOCTShortGameShot = (id, date) => {

    var payload = {
        "id": id,
        "date": date
    }
    return (dispatch) => {
        dispatch({ type: OCTSHORTGAME_ACTION, });
        return axios.post(AppConfig.apiurl + '/api/getcrdetails', payload, { headers: AuthHeader.header })
            .then(response => {
                var resdata = response.data;
                if (resdata.status === 1) {
                    dispatch({ type: FETCH_OCTSHORTGAME, payload: resdata.data });
                }
                return Promise.resolve(resdata);

            });

    }
}

export const editOCTShortGameShot = (data, sepmore, olddate) => {
    var id=data.target.student.value;
    var payload = {
        "totval": 1,
        "student": data.target.student.value,
        "sgdate": data.target.seldate.value,
        "shtot_1": sepmore,
        "olddate": olddate,
    }

    for (let i = 0; i < sepmore; i++) {

        var distance = 'shot_' + i;
        var distanceval = data.target[distance].value;
        var right = 'right_' + i;
        var rightval = data.target[right].value;
        var left = 'left_' + i;
        var leftval = data.target[left].value;
        var short = 'short_' + i;
        var shortval = data.target[short].value;
        var long = 'long_' + i;
        var longval = data.target[long].value;
        var area = 'area_' + i;
        var areaval = data.target[area].value;
        var contact='contact_'+i;            
        var contactval=data.target[contact].value;
        var sepopt = 'putt_' + i;
        var seoptval = data.target[sepopt].value;
        var septravel = 'missedgreen_' + i;
        var setrvalval = data.target[septravel].value;

        var adval = i + 1;
        var distadd = 'shottype_1_' + adval;
        var rightadd = 'right_1_' + adval;
        var leftadd = 'left_1_' + adval;
        var shortadd = 'short_1_' + adval;
        var longadd = 'long_1_' + adval;
        var areaadd = 'area_1_' + adval;
        var contadd='contact_1_'+adval;
        var sepoptadd = 'putt_1_' + adval;
        var septraveladd = 'dhg_1_' + adval;

        payload[distadd] = distanceval;
        payload[rightadd] = rightval;
        payload[leftadd] = leftval;
        payload[shortadd] = shortval;
        payload[longadd] = longval;
        payload[areaadd] = areaval;
        payload[contadd] = contactval;
        payload[sepoptadd] = seoptval;
        payload[septraveladd] = setrvalval;

    }

    return (dispatch) => {
        dispatch({ type: OCTSHORTGAME_ACTION, });
        return axios.post(AppConfig.apiurl + '/api/editcourserandom', payload, { headers: AuthHeader.header })
            .then(response => {
                var resdata = response.data;
                if (resdata.status === 1) {
                    studentOCTShortGame(id, '', '')(dispatch);
                    fetchShortGameShotChart(id, '', '', '', '', '')(dispatch);
                    NotificationManager.success(resdata.message);
                    dispatch({ type: EDIT_OCTSHORTGAME });
                }
                return Promise.resolve(resdata);

            });

    }
}

export const deleteOCTShortGame = (id, date) => {

    var payload = {
        "id": id,
        "date": date
    }
    return (dispatch) => {
        dispatch({ type: OCTSHORTGAME_ACTION, });
        return axios.post(AppConfig.apiurl + '/api/deletecourserandom', payload, { headers: AuthHeader.header })
            .then(response => {
                var resdata = response.data;
                if (resdata.status === 1) {
                    studentOCTShortGame(id, '', '')(dispatch);
                    fetchShortGameShotChart(id, '', '', '', '', '')(dispatch);
                    NotificationManager.success(resdata.message);
                    dispatch({ type: DELETE_OCTSHORTGAME });
                }

            });

    }
}

export const fetchShortGameShotChart = (id, start, end, distance, area, contact) =>{
    
    var payload={
        "id":id,
        "startdate":start,
        "enddate":end,
        "contact":contact,
        "distance":distance,
        "area":area             
    }

    return (dispatch) => { 
        dispatch({ type:OCTSHORTGAME_ACTION, });
        return axios.post(AppConfig.apiurl+'/api/oncourserandomreport', payload,{ headers: AuthHeader.header })         
        .then(response => {             
            var resdata=response.data.data;
            var course=resdata.course;
            dispatch({ type: FETCH_OCTSHORTGAMECHART, payload: course}); 
            
            return Promise.resolve(resdata);
            
        });
    
    }
}

export const fetchOnShortShotChart = (id, start, end, distance, area, contact, val) =>{
    
    var payload={
        "id":id,
        "startdate":start,
        "enddate":end,
        "contact":contact,
        "distance":distance,
        "area":area,
        "section":val            
    }

    return (dispatch) => { 
        dispatch({ type:OCTSHORTGAME_ACTION, });
        return axios.post(AppConfig.apiurl+'/api/onwedgeshotchart', payload,{ headers: AuthHeader.header })         
        .then(response => {             
            var resdata=response.data.data;
            dispatch({ type: FETCH_SHORTSHOTCHART, payload: resdata}); 
            
            return Promise.resolve(resdata);
            
        });
    
    }
}